import React from "react";

function View(props, { locals }) {
  return (
    <div id="login-wrapper">
      <img
        className="logo"
        src="/img/msb-logo-white.svg"
        alt="My Stength Book"
      />
      <div className="frame">
        <h1 className="alt">Privacy Policy</h1>
        <p>
          We collect information from visitors on our website through contact
          form requests. The information we collect online includes names, email
          address, and phone number.
        </p>
        <p>
          MyStrengthBook uses your information to communicate with you, and
          understand your needs to provide you with better service. We may use
          your information to complete a transaction, to update you with
          information you have subscribed to receive, or to personalize our
          website for you.
        </p>
        <p>
          MyStrengthBook never sells, rents, leases, or exchanges your personal
          information with other organizations. We assure you that the identity
          of all who contact us through this website will be kept confidential.
        </p>
        <p>
          MyStrengthBook will track session activity using a third party
          technology. The information collected during each session will be kept
          confidential and will only be used for beta testing optimization only.
        </p>
        <p>
          MyStrengthBook reserves the right to modify our Privacy Policy at any
          time.
        </p>
        <p>
          If you have any questions about our terms of use or privacy policy, or
          would like more information about MyStrengthBook, or are experiencing
          technical trouble, please{" "}
          <a href="mailto:info@mystrengthbook.com">contact us</a>.
        </p>
      </div>
    </div>
  );
}

const PrivacyPolicy = (app) => {
  app.get("/privacy-policy", ({ res }) => (res.body = <View />));
};

export default PrivacyPolicy;
